module.exports = __webpack_public_path__ + "img/logo.a1b562d3.png";